import { Component } from 'react'
import PropTypes from 'prop-types'
import store from 'config/store/'
import { view_types } from 'config/viewTypes'
import { dataset } from 'config/types/dataset'

class BaseContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      custom_event_triggered: false,
      content: null,
      form_success: false,
      view_types: view_types,
      hide_component_present: this.changeStatus(store.getState().view)
    }

    this.storedContainer = null
    this.showSuccess     = null
    this.viewStatus      = view_types.new
    this.componentName   = null
    this.dataset         = dataset
    this.mainId = this.props.mainId;
  }

  addClassToModalPopupOverlay(currentState) {
    const element = document.querySelector(`#${this.mainId}`).dataset.parent;

    // If the element doesnt have data-parent attribute does not add classes
    // We need them only for modal popup overlay.
    if( !element ){
      return;
    }

    const parent     = document.querySelector(`#${element}`) || null;
    const stateClass = 'state-' + currentState;

    if(currentState){
      parent.classList.remove('state-new', 'state-soi', 'state-doi');
      parent.classList.add(stateClass);

    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if( prevState.form_success === true && nextProps.view !== 'new') {
      return { form_success: false };
    }
    return null;
  }

  shouldComponentUpdate() {
    this.addClassToModalPopupOverlay(this.state.user_status);

    if(this.state.form_success === true && this.state.user_status === 'new') {
      return false;
    }

    if(this.state.form_success === true && this.state.user_status === 'doi') {
      return false;
    }

    if(this.state.user_status === 'soi') {
      return true;
    }

    return true;
  }

  changeFormSuccess = (user_status) => {
    this.setState({ form_success: true, user_status })
  }

  latestCalled() {
    if(this.getStoredContainer() === this.componentName) {
      this.viewStatus  = view_types.new
      this.showSuccess = true
      localStorage.removeItem('container')
    }
  }

  getStoredContainer() {
    return localStorage.getItem('container');
  }

  changeStatus(status) {
    return (status === view_types.doi) ? true : false
  }
}

BaseContainer.propTypes = {
  mainId: PropTypes.string.isRequired
}

export default BaseContainer
